import { useState, useEffect } from 'react';


const VoiceSelector = ({ voices, selectedVoice, onVoiceSelect }) => {
  const [selectedGender, setSelectedGender] = useState(null);
  const [selectedAgeGroup, setSelectedAgeGroup] = useState(null);

  // Get available genders
  const availableGenders = Object.keys(voices).filter(gender => 
    Object.keys(voices[gender]).length > 0
  );

  // Get available age groups for selected gender
  const availableAgeGroups = selectedGender ? 
    Object.keys(voices[selectedGender]).filter(ageGroup => 
      voices[selectedGender][ageGroup].length > 0
    ) : [];

  // Get available voices for selected gender and age group
  const availableVoices = (selectedGender && selectedAgeGroup) ? 
    voices[selectedGender][selectedAgeGroup] : [];

  // Auto-select a random voice when voices are available and no voice is selected
  useEffect(() => {
    if (!selectedVoice && voices && Object.keys(voices).length > 0) {
      // Get all available voices from all genders and age groups
      const allVoices = [];
      Object.keys(voices).forEach(gender => {
        Object.keys(voices[gender]).forEach(ageGroup => {
          voices[gender][ageGroup].forEach(voice => {
            allVoices.push(voice);
          });
        });
      });

      if (allVoices.length > 0) {
        // Select a random voice
        const randomIndex = Math.floor(Math.random() * allVoices.length);
        const randomVoice = allVoices[randomIndex];
        onVoiceSelect(randomVoice);
      }
    }
  }, [voices, selectedVoice, onVoiceSelect]);

  const handleVoiceSelect = (voice) => {
    onVoiceSelect(voice);
    // Don't set preview since voice and video are now separate
  };

  const resetSelection = () => {
    setSelectedGender(null);
    setSelectedAgeGroup(null);
    // Don't reset the voice selection - keep the currently selected voice
  };

  const selectRandomVoice = () => {
    if (voices && Object.keys(voices).length > 0) {
      // Get all available voices from all genders and age groups
      const allVoices = [];
      Object.keys(voices).forEach(gender => {
        Object.keys(voices[gender]).forEach(ageGroup => {
          voices[gender][ageGroup].forEach(voice => {
            allVoices.push(voice);
          });
        });
      });

      if (allVoices.length > 0) {
        // Select a random voice
        const randomIndex = Math.floor(Math.random() * allVoices.length);
        const randomVoice = allVoices[randomIndex];
        onVoiceSelect(randomVoice);
      }
    }
  };

  return (
    <div className="voice-selector">
      {!selectedGender ? (
        // Gender selection
        <div className="gender-selection">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="text-muted" style={{fontSize: "12px"}}>
              Choose a gender:
            </div>
            <button 
              className="btn btn-primary btn-sm"
              onClick={selectRandomVoice}
            >
              <i className="fa fa-random me-1"></i> Random Voice
            </button>
          </div>
          <div className="row pt-2 animation-preview-wrapper">

            {availableGenders.map(gender => (
              <div className="col-md-3 col-3" key={gender}>
                <button
                  className="btn btn-primary upcoming-session-action-button"
                  onClick={() => setSelectedGender(gender)}
                >
                  <i className={`fa ${gender === 'Male' ? 'fa-mars' : 'fa-venus'} me-1`}></i>
                  {gender}
                </button>
              </div>
            ))}
          </div>
        </div>
      ) : !selectedAgeGroup ? (
        // Age group selection
        <div className="age-group-selection">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="text-muted" style={{fontSize: "12px"}}>
              Choose age group for {selectedGender}:
            </div>
            <button 
              className="btn btn-primary btn-sm"
              onClick={resetSelection}
            >
              <i className="fa fa-arrow-left me-1"></i> Back
            </button>
          </div>
          <div className="row pt-2 animation-preview-wrapper">
            {availableAgeGroups.map(ageGroup => (
              <div className="col-md-3 col-3" key={ageGroup}>
                <button
                  className="btn btn-primary upcoming-session-action-button"
                  onClick={() => setSelectedAgeGroup(ageGroup)}
                >
                  {ageGroup}
                </button>
              </div>
            ))}
          </div>
        </div>
      ) : (
        // Voice selection
        <div className="voice-selection">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="text-muted" style={{fontSize: "12px"}}>
              Choose voice for {selectedGender} {selectedAgeGroup}:
            </div>
            <button 
              className="btn btn-primary btn-sm"
              onClick={() => setSelectedAgeGroup(null)}
            >
              <i className="fa fa-arrow-left me-1"></i> Back
            </button>
          </div>
          <div className="row pt-2 animation-preview-wrapper">
            {availableVoices.map(voice => (
              <div className="col-md-3 col-3" key={voice.name}>
                <button
                  className={`btn btn-primary upcoming-session-action-button ${selectedVoice?.name === voice.name ? 'selected' : ''}`}
                  onClick={() => handleVoiceSelect(voice)}
                >
                  <i className="fa fa-volume-up me-1"></i>
                  {voice.name}
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default VoiceSelector;